const PreviewTableThree = ({ work }) => {
    return ( 
            <table className="mt-2">
                <thead>
                    <tr>
                        <th>Period</th>
                        <th>Job Title</th>
                        <th>Employer Name</th>
                        <th>Address</th>
                    </tr>
                    </thead>
                    <tbody>            
                        {
                            work && work.map(job => (
                                <tr key={job.employerName}>
                                    <td>{job.fromDate} to {job.toDate}</td>
                                    <td>{job.occupation}</td>    
                                    <td>{job.employerName}</td>    
                                    <td>{job.workAddress}</td>   
                                </tr>
                            ))
                        } 
                </tbody>
            </table>
     );
}
 
export default PreviewTableThree;